import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  formatSessionNameForURL,
  isWindowInIframe,
  replaceDashesWithSpaces,
} from "../../v2_actions/nav";

import DesktopEventList from "./DesktopEventList";
import AlbumPageFilter from "./AlbumPageFilter";
import { EventPageBreadCrumbs } from "./EventPageBreadcrumbs";
import { EventsLayout } from "../layout/EventsLayout";
import LoadingSpinner from "../../views/components/LoadingSpinner";
import MobileEventList from "../MobileEventList";
import ReactGA from "react-ga4";
import SubEventFilter from "../SubEventFilter";
import { basePhotographList } from "../../v2_actions/customer_photograph";
import { setGalleryNavBackButtonUrl } from "../../v2_actions/nav";
import { useEventsPageStartupEffects } from "../hooks/useEventsPageStartupEffects";
import { useIsMobile, TOP_PADDING_PX, VIEWPORT_HEIGHT } from "../../actions/ui";
import { useParams, useSearchParams } from "react-router-dom";

export const AlbumPage = () => {
  const dispatch = useDispatch();
  setGalleryNavBackButtonUrl();
  const isMobile = useIsMobile();
  const isInIframe = isWindowInIframe();
  const [searchParams, setSearchParams] = useSearchParams();
  const { album_name } = useParams();
  const { gallery_event_name } = useParams();
  const { publicUrlPathForGalleryEvent } = useParams();
  const albumNameForAPI = replaceDashesWithSpaces(album_name);
  const galleryEventNameForAPI = replaceDashesWithSpaces(gallery_event_name);
  const galleryEventNameForURL = formatSessionNameForURL(gallery_event_name);

  const isLoadingStaticData = useEventsPageStartupEffects({ isAlbumPage: true });

  useEffect(() => {
    if (gallery_event_name) {
      ReactGA.event({
        category: "Events/Schools",
        label: `${gallery_event_name}`,
        action: "Entered an events/school page",
      });
    }
    return () => {
      if (gallery_event_name) {
        ReactGA.event({
          category: "Events/Schools",
          label: `${gallery_event_name}`,
          action: "Exited an events/school page",
        });
      }
    };
  }, [gallery_event_name]);

  useEffect(() => {
    dispatch(basePhotographList.clearListFilter());

    const hasSearchParams = !!searchParams.toString();
    if (hasSearchParams) {
      setSearchParams({});
    }
  }, [])

  if (isLoadingStaticData) {
    return (
      <EventsLayout activeTab="events" isInIframe={isInIframe}>
        <LoadingSpinner />
      </EventsLayout>
    );
  }

  return (
    <EventsLayout activeTab="events" isInIframe={isInIframe}>
      <Box
        sx={{
          mx: "auto",
          pt: `${TOP_PADDING_PX}px`,
          height: VIEWPORT_HEIGHT,
          display: "flex",
        }}
      >
        <Grid container spacing={2} sx={{ flex: 1, height: "100%" }}>
          <Grid
            item
            sm={5}
            md={4}
            lg={3}
            xl={2.5}
            sx={{
              alignSelf: "flex-start",
              position: "sticky",
              top: `${TOP_PADDING_PX}px`,
              maxHeight: VIEWPORT_HEIGHT,
              overflowY: "hidden",
              pr: 1,
            }}
          >
            <AlbumPageFilter
              albumNameForAPI={albumNameForAPI}
              galleryEventNameForURL={galleryEventNameForURL}
            />
          </Grid>
          <Grid
            item
            sm={7}
            md={8}
            lg={9}
            xl={9.5}
            sx={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <Box
              sx={{
                flex: 1,
                overflowY: "auto",
                pr: 1,
                pb: 2,
                WebkitOverflowScrolling: "touch",
              }}
            >
              <DesktopEventList
                album_name={albumNameForAPI}
                gallery_event_name={galleryEventNameForAPI}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    </EventsLayout>
  );
};
